import { ModelBase } from '../../core/model/model-base';

export class PropertyAppendix extends ModelBase {
  constructor(dataContext?: any) {
    super();
    if (dataContext) {
      this.id = dataContext.id;
      this.property = dataContext.property;
      this.appendix = dataContext.appendix;
      this.sortOrder = dataContext.sortOrder;
    }
  }

  property: string;
  appendix: string;
  sortOrder: number;

  toJSON() {
    let json = Object.assign({}, this);
    return json;
  }
}
